import React from 'react';
import p from 'translation';
import { App } from 'core/types/app';
import { RoleId } from 'core/types/role';

import { ReactComponent as ActivityIcon } from './icon/activity.svg';
import { ReactComponent as ContentIcon } from './icon/content.svg';
import { ReactComponent as TemplatesIcon } from './icon/rectangle-history.svg';
import { ReactComponent as MessageIcon } from './icon/message.svg';
import { ReactComponent as ImageIcon } from './icon/image.svg';
import { ReactComponent as VideoCallIcon } from './icon/video-call.svg';
import icon from './icon.svg';

const roles: RoleId[] = [
  'share:videocaller',
  'share:reader',
  'share:user',
  'share:manager',
  'organization:administrator',
];

function hasMinimum(minimum: RoleId, role: RoleId): boolean {
  return roles.indexOf(minimum) <= roles.indexOf(role);
}

const share: App = {
  id: 'share',
  name: p.t('apps.share.title'),
  icon,
  color: {
    main: '#007373',
    light: '#48A1A0',
    dark: '#004647',
    contrastText: '#fff',
  },
  app: React.lazy(() => import(/* webpackChunkName: "share" */ './app')),
  navigation: [
    {
      title: p.t('apps.share.content.title'),
      path: '/',
      hasAccess: role => hasMinimum('share:reader', role),
      icon: <ContentIcon />,
    },
    {
      title: p.t('apps.share.templates.title'),
      path: '/templates',
      hasAccess: role => hasMinimum('share:reader', role),
      icon: <TemplatesIcon />,
    },
    {
      title: p.t('apps.share.message.title'),
      path: '/message',
      hasAccess: role => hasMinimum('share:user', role),
      icon: <MessageIcon />,
    },
    {
      title: p.t('apps.share.image.title'),
      path: '/image',
      hasAccess: role => hasMinimum('share:user', role),
      icon: <ImageIcon />,
    },
    {
      title: p.t('apps.share.video-call.title'),
      path: '/video-call',
      hasAccess: role => hasMinimum('share:videocaller', role),
      icon: <VideoCallIcon />,
    },
    {
      title: p.t('apps.share.activity.title'),
      path: '/activity',
      hasAccess: role => hasMinimum('share:reader', role),
      icon: <ActivityIcon />,
    },
  ],
};

export default share;
